import { useEffect, useState } from "react";
import { Button, Modal } from "flowbite-react";
import { trocDoneOfRes } from "../../../services/callAPI/trocsPropositions";
import ValidToast from "../../toasts/ValidToast";
import UnvalidToast from "../../toasts/UnvalidToast";

interface ITrocDoneOfResProps {
  resTrocId: number,
  travTrocId: number,
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>;
}

function TrocDoneRes(props: ITrocDoneOfResProps) {
  //destructuring
  const { resTrocId, travTrocId, setTrigUseEffect } = props;

  const [isShowValidToast, setIsShowValidToast] = useState<boolean>(false);

  const [isShowUnvalidToast, setIsShowUnvalidToast] = useState<boolean>(false);

  const [openModal, setOpenModal] = useState(false);


  async function handleServiceDone(resTrocId: number, travTrocId: number) {
    try {

      const status = await trocDoneOfRes(resTrocId, travTrocId);

      if (status === 204) {
        //show ValidToast
        setIsShowValidToast(true);
      }
      else {
        throw new Error(`Erreur interne. Mise à jour impossible.`);
      }
    } catch (error) {
      //show UnvalidToast
      setIsShowUnvalidToast(true);
    } finally {
      setOpenModal(false);
    }
  }

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isShowValidToast) {
      timer = setTimeout(() => {
        setTrigUseEffect(prev => !prev);
      }, 3000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isShowValidToast]);


  return (
    <>
      {isShowValidToast && <ValidToast />}
      {isShowUnvalidToast && <UnvalidToast />}

      <Button
        id="btn-accept-proposal"
        onClick={() => setOpenModal(true)}
        className="bg-greenCustom w-1/2 max-w-32 p-0"
      >
        Troc effectué ?
      </Button>

      <Modal
        show={openModal}
        size="md"
        onClose={() => setOpenModal(false)}
        popup
        className="bg-transparent backdrop-blur-sm"
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              On s'est rendu service ?
            </h3>
            <div className="flex justify-center gap-4">
              <Button className="bg-greenCustom" onClick={() => handleServiceDone(resTrocId, travTrocId)}>
                {"Oui, c'est fait"}
              </Button>
              <Button className="bg-lightRedCustom" onClick={() => setOpenModal(false)}>
                Non, pas encore
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default TrocDoneRes;